import { tryCatch, always, pipe, prop, applySpec, __ } from 'ramda';
import stc from 'string-to-color';

export const resolveDebt = (debt?: any): Debt => {
    const p = prop(__, debt);

    return {
        amount: p('Amount'),
        description: p('Glosa'),
        period: p('Periodo'),
        currency: p('Moneda'),
        type: p('Tipo'),
        state: p('EstadoDeuda'),
        transaction: p('TransaccionID'),
        service: p('ServicioID'),
        id: p('ID'),
        siblingsIds: [],
        createdAt: p('CreatedDate'),
        debtInfo: p('Intersocio_info')
            ? pipe(
                  tryCatch((jsonValue) => JSON.parse(jsonValue), always({})),
                  applySpec({
                      type: prop('type'),
                      resourceId: prop('resource_id'),
                      chargeId: prop('charge_id'),
                  })
              )(debt.Intersocio_info)
            : {},
        info: p('Intersocio_info')
            ? tryCatch((jsonValue) => JSON.parse(jsonValue), always(null))(debt.Intersocio_info)
            : debt.info || null,
        groupColor: () => stc(debt.debtInfo.resourceId + 20),
    };
};
